import { useTranslation } from "@/packages/utils";
import type { NotificationRenderer } from "./types";
import { StatusTransitionWidget } from "../StatusTransitionWidget";
import { NotificationMetadataCard } from "../NotificationMetadataCard";
import { BodyCard } from "./BodyCard";
import type { NotificationDetail } from "../types";

function AuditStatusChangeContent({
  notification,
}: {
  notification: NotificationDetail;
}) {
  const { t } = useTranslation("inbox");

  const { previousStatus, newStatus, changedBy, ...rest } =
    notification.metadata ?? {};

  const filteredMeta = Object.fromEntries(
    Object.entries(rest).filter(
      ([k]) => !["previousStatus", "newStatus", "changedBy"].includes(k),
    ),
  );

  const translatedPrev = previousStatus
    ? t(`statusValues.${previousStatus}`, { defaultValue: previousStatus })
    : "";
  const translatedNew = newStatus
    ? t(`statusValues.${newStatus}`, { defaultValue: newStatus })
    : "";

  const translatedBody = t("notificationBodies.audit_status_change", {
    defaultValue: "",
    auditName: notification.relatedEntityName,
    previousStatus: translatedPrev,
    newStatus: translatedNew,
  });

  const body = translatedBody || notification.body;

  return (
    <>
      {previousStatus && newStatus && (
        <StatusTransitionWidget
          from={previousStatus}
          to={newStatus}
          changedBy={changedBy}
        />
      )}
      <BodyCard body={body} delay={0.15} />
      {Object.keys(filteredMeta).length > 0 && (
        <NotificationMetadataCard metadata={filteredMeta} />
      )}
    </>
  );
}

export const AuditStatusChangeRenderer: NotificationRenderer = {
  render: (notification) => (
    <AuditStatusChangeContent notification={notification} />
  ),
};
